import React from 'react';
import propTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { pensionCashflowTransactions, globalQuotesView } from '../../redux/reducers/data';
import ChartWrapper from '../reports/ChartWrapper';
import ToolTip from '../../elements/ToolTip';

export default function PensionIndicators({ accountId }) {
  const { t } = useTranslation('accountDetails', { keyPrefix: 'pensionIndicators' });

  const accounts = useSelector((state) => state.data.pension.accounts);
  const thisAccount = accounts.find((a) => a.id === accountId);
  const transactions = useSelector(pensionCashflowTransactions);
  const thisAccountTransactions = transactions.filter((tx) => tx.tags?.accountId === accountId || tx.tags?.assetId === accountId);
  const sumContributions = thisAccountTransactions.filter((tx) => tx.label === 'investment-contribution').reduce((acc, tx) => acc + tx.quantity, 0);
  const quotes = useSelector(globalQuotesView);

  console.info('DEBUG this account quotes', quotes[accountId]);
  const presentValue = quotes[accountId].current.quoteBaseCurrency * 1; // FIX 251206 see PRD-1759 / Pensions 2.0
  const percentPVToContributions = sumContributions ? presentValue / -sumContributions : 0; // contributions are negative (done so automatically by Grid)

  const accountCurrency = thisAccount.currency;

  return (
    <div className="w-full gap-2 grid">
      <div className="relative p-2 sm:p-4 w-full border border-gray-300 rounded-lg col-span-2">
        <h3 className="font-bold text-base sm:text-lg mb-1 sm:mb-2 col-span-3">{t('presentValueChanges')}</h3>
        <ChartWrapper
          reportId="quotesByAssetIdxxxxxx"
          filterCallback={(item) => item.assetId === accountId}
          layoutOptions={{
            axisBottom: { tickRotation: -90 },
            margin: { top: 60 },
          }}
        />
      </div>
      {/* show this only if there is a currentQuote */}
      {presentValue && (
        <div className="p-2 sm:p-4 w-full border border-gray-300 rounded-lg col-span-2 grid grid-cols-2">
          <h3 className="font-bold text-base sm:text-lg mb-1 sm:mb-2 col-span-3">{t('roi')}</h3>
          <div>
            <div className="text-xs xs:text-sm flex">
              {t('sumContributions')}
              <ToolTip info={t('sumContributionsTooltip')} />
            </div>
            <div className="text-[1rem] transform scale-y-110 sm:scale-y-100 font-bold text-gray-900 sm:flex sm:items-baseline lg:block xl:flex gap-1 xl:text-xl">
              {Math.abs(sumContributions).toLocaleString('de', { style: 'currency', currency: accountCurrency })}
            </div>
          </div>
          <div>
            <div className="text-xs xs:text-sm flex">
              {t('presentValue')}
              <ToolTip info={t('presentValueTooltip')} />
            </div>
            <div className="text-[1rem] transform scale-y-110 sm:scale-y-100 font-bold text-gray-900 sm:flex sm:items-baseline lg:block xl:flex gap-1 xl:text-xl">
              {presentValue.toLocaleString('de', { style: 'currency', currency: accountCurrency })}
              <span className={`${percentPVToContributions >= 1 ? 'text-green-500' : 'text-brandRed-500'} flex items-baseline text-xs sm:text-sm font-semibold`}>
                {percentPVToContributions.toLocaleString('de', { style: 'percent', maximumFractionDigits: 1 })}
              </span>
            </div>
            {/* add presentValue as % of contribution */}
          </div>
        </div>
      )}
    </div>
  );
}
PensionIndicators.propTypes = {
  accountId: propTypes.string.isRequired,
};
